import React from "react";
import { Divider, Box, RaiseColors, makeStyles } from "client/componentLibrary";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    cardContainer: {
      borderRadius: "4px",
      border: "1px solid ".concat(RaiseColors.gray100),
      position: "relative",
      width: "100%"
    },
    carouselContainer: {
      cursor: "pointer",
      overflow: "hidden",
      borderRadius: "3px 3px 0px 0px",
      // Sets 3:2 Ratio on the carousel container
      position: "relative",
      width: "100%",
      paddingTop: "66.66%",
      "& img": {
        height: "100%"
      }
    },
    carousel: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    body: {
      padding: "12px 16px 15px 16px",
      "&:hover": {
        cursor: "pointer"
      }
    },
    coreAttributes: {
      padding: "16px 0px 0px 0px",
      display: "flex"
    },
    engagementSection: {
      margin: "12px 0px",
      minHeight: 22
    }
  };
});
var VerticalListingCardLoading = function VerticalListingCardLoading(_ref) {
  var FileCarouselSection = _ref.FileCarouselSection,
    EngagementSection = _ref.EngagementSection;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs(Box, {
    className: classes.cardContainer,
    children: [/*#__PURE__*/_jsx(Box, {
      className: classes.carouselContainer,
      children: /*#__PURE__*/_jsx(Box, {
        className: classes.carousel,
        children: FileCarouselSection
      })
    }), /*#__PURE__*/_jsx(Divider, {
      color: RaiseColors.gray100
    }), /*#__PURE__*/_jsxs(Box, {
      className: classes.body,
      children: [/*#__PURE__*/_jsx(Box, {
        bgcolor: RaiseColors.gray200,
        width: 120,
        height: 14
      }), /*#__PURE__*/_jsx(Box, {
        mt: 0.5,
        children: /*#__PURE__*/_jsx(Box, {
          bgcolor: RaiseColors.gray200,
          width: 140,
          height: 14
        })
      }), /*#__PURE__*/_jsx(Box, {
        mt: 0.25,
        children: /*#__PURE__*/_jsx(Box, {
          bgcolor: RaiseColors.gray200,
          width: 180,
          height: 14
        })
      }), /*#__PURE__*/_jsxs(Box, {
        className: classes.coreAttributes,
        children: [/*#__PURE__*/_jsxs(Box, {
          width: "50%",
          children: [/*#__PURE__*/_jsx(Box, {
            bgcolor: RaiseColors.gray200,
            width: 100,
            height: 14
          }), /*#__PURE__*/_jsx(Box, {
            bgcolor: RaiseColors.gray200,
            width: 100,
            height: 14,
            mt: 0.5
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          ml: 2.5,
          children: [/*#__PURE__*/_jsx(Box, {
            bgcolor: RaiseColors.gray200,
            width: 100,
            height: 14
          }), /*#__PURE__*/_jsx(Box, {
            bgcolor: RaiseColors.gray200,
            width: 100,
            height: 14,
            mt: 0.5
          })]
        })]
      })]
    }), EngagementSection && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Divider, {
        color: RaiseColors.gray100
      }), /*#__PURE__*/_jsx(Box, {
        className: classes.engagementSection,
        children: EngagementSection
      })]
    })]
  });
};
export default VerticalListingCardLoading;